import { Link } from 'react-router-dom';
import css from './cookies-policy.module.scss';
import BackButton from 'src/components/buttons/back-button';

export default function CookiesPolicy() {
  return (
    <main className={css.container}>
      <div className={css.headerWrapper}>
        <BackButton backLink='/' />

        <div className={css.breadcrumbs}>
          <Link to='/' className={css.link}>
            Головна
          </Link>
          <span>{'>'}</span>
          <span className={css.link}>Політика використання файлів cookie</span>
        </div>
      </div>

      <article>
        <h1>Політика використання файлів cookie</h1>

        <p>
          <b>1. Вступ</b>
        </p>
        <p>
          Ця Політика використання файлів cookie пояснює, як наш вебсайт використовує файли cookie та інші подібні
          технології для покращення вашого досвіду користування. Продовжуючи користуватися нашим сайтом, ви погоджуєтеся
          на використання файлів cookie відповідно до цієї Політики.{' '}
        </p>
        <br />

        <p>
          <b>2. Що таке файли cookie?</b>
        </p>
        <p>
          Файли cookie - це невеликі текстові файли, які зберігаються на вашому пристрої (комп’ютері, планшеті,
          смартфоні) при відвідуванні вебсайтів. Вони допомагають вебсайту запам’ятовувати інформацію про ваш візит, що
          може полегшити ваше наступне відвідування та зробити сайт кориснішим для вас.{' '}
        </p>
        <br />

        <p>
          <b>3. Які файли cookie ми використовуємо?</b>
        </p>
        <ul>
          <li>
            Необхідні файли cookie: Ці файли cookie є необхідними для роботи вебсайту і не можуть бути відключені в
            наших системах. Вони зазвичай встановлюються у відповідь на ваші дії, такі як заповнення форм або
            налаштування параметрів конфіденційності.
          </li>
          <li>
            Аналітичні файли cookie: Ці файли cookie дозволяють нам підраховувати кількість відвідувачів і джерела
            трафіку, щоб ми могли вимірювати та покращувати продуктивність нашого сайту. Вони допомагають нам дізнатися,
            які сторінки є найбільш і найменш популярними.
          </li>
          <li>
            Функціональні файли cookie: Ці файли cookie дозволяють сайту надавати розширені функціональні можливості та
            персоналізацію. Вони можуть бути встановлені нами або сторонніми провайдерами, чиї послуги ми додали на наші
            сторінки.
          </li>
          <li>
            Рекламні файли cookie: Ці файли cookie використовуються для відстеження відвідувачів на вебсайтах. Намір
            полягає в тому, щоб показувати рекламу, яка є релевантною та цікавою для окремого користувача.
          </li>
        </ul>

        <p>
          <b>4. Як ви можете керувати файлами cookie?</b>
        </p>
        <p>
          Ви можете налаштувати свій браузер на блокування або попередження про файли cookie, але якщо ви зробите це,
          деякі частини сайту можуть не працювати. Ось посилання на керівництва з керування файлами cookie для основних
          веббраузерів:
        </p>
        <ul>
          <li>
            <a href='https://policies.google.com/technologies/cookies?hl=uk' target='_blank' rel='noreferrer noopener'>
              Google Chrome
            </a>
          </li>
          <li>
            <a
              href='https://www.mozilla.org/uk/privacy/websites/cookie-settings/'
              target='_blank'
              rel='noreferrer noopener'>
              Mozilla Firefox
            </a>
          </li>
          <li>
            <a
              href='https://support.microsoft.com/uk-ua/windows/%D0%BA%D0%B5%D1%80%D1%83%D0%B2%D0%B0%D0%BD%D0%BD%D1%8F-%D1%84%D0%B0%D0%B9%D0%BB%D0%B0%D0%BC%D0%B8-cookie-%D0%B2-microsoft-edge-%D0%BF%D0%B5%D1%80%D0%B5%D0%B3%D0%BB%D1%8F%D0%B4-%D0%B4%D0%BE%D0%B7%D0%B2%D1%96%D0%BB-%D0%B1%D0%BB%D0%BE%D0%BA%D1%83%D0%B2%D0%B0%D0%BD%D0%BD%D1%8F-%D0%B2%D0%B8%D0%B4%D0%B0%D0%BB%D0%B5%D0%BD%D0%BD%D1%8F-%D1%82%D0%B0-%D0%B2%D0%B8%D0%BA%D0%BE%D1%80%D0%B8%D1%81%D1%82%D0%B0%D0%BD%D0%BD%D1%8F-168dab11-0753-043d-7c16-ede5947fc64d'
              target='_blank'
              rel='noreferrer noopener'>
              Internet Explorer
            </a>
          </li>
          <li>
            <a
              href='https://support.apple.com/uk-ua/guide/deployment/depf7d5714d4/web'
              target='_blank'
              rel='noreferrer noopener'>
              Safari
            </a>
          </li>
        </ul>

        <p>
          <b>5. Зміни до Політики використання файлів cookie</b>
        </p>
        <p>
          Ми можемо час від часу оновлювати цю Політику використання файлів cookie, щоб відобразити зміни в наших
          практиках і послугах. Коли ми опублікуємо зміни до цієї Політики, ми оновимо дату останнього перегляду.{' '}
        </p>
        <br />

        <p>
          <b>6. Контактна інформація </b>
          <p>
            Якщо у вас є будь-які питання або коментарі щодо цієї Політики використання файлів cookie, будь ласка,
            зв’яжіться з нами.
          </p>
        </p>
      </article>

      <div>
        <BackButton />
      </div>
    </main>
  );
}
